<ion-content>
  <div class="time-container" *ngFor="let o of options" (click)="timeOptionSelected(o)">
    <p class="option">{{o.text}}</p>
  </div>
</ion-content>
